module.exports = __webpack_public_path__ + "img/7.5de72a31.png";